/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface IFieldViewSelectorProps {
	className?: string;
}

export const FieldViewSelector: React.FC<IFieldViewSelectorProps> = ({ className }) => {
	const baseClass = BEM("edt-field-view-selector");

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			<div className={baseClass.element("element").toClassName()}></div>
		</div>
	);
};
